export default "__VITE_ASSET__DA20UZkC__"